function applyGradientToTitles(selector) {
  const titles = document.querySelectorAll(".mrp_produto_display h3");

  titles.forEach((title) => {
    const lineHeight = parseFloat(getComputedStyle(title).lineHeight);
    const maxHeight = lineHeight * 2;

    // Adiciona ou remove a classe 'has-gradient' conforme necessário
    if (title.scrollHeight > maxHeight) {
      title.classList.add("has-gradient");
    } else {
      title.classList.remove("has-gradient");
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  // Itera por cada acordeão dentro de uma section específica
  document.querySelectorAll("[data-accordion]").forEach((accordion) => {
    accordion.querySelectorAll(".accordion-header").forEach((header) => {
      header.addEventListener("click", function () {
        const item = this.parentElement;
        item.classList.toggle("active");
      });
    });
  });
});

// Seleciona o contêiner principal
const carrossel = document.querySelector(".carrossel-diferenciais");

// Adiciona o evento de clique nos itens dentro do contêiner
carrossel.querySelectorAll(".carrossel-diferenciais-item").forEach((item) => {
  item.addEventListener("click", () => {
    // Fecha todos os outros itens apenas dentro do contêiner
    carrossel.querySelectorAll(".carrossel-diferenciais-item").forEach((i) => {
      if (i !== item) {
        i.classList.remove("active");
      }
    });

    // Alterna o estado do item clicado
    item.classList.toggle("active");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Reaplica os eventos para novos carrosséis quando a página ou uma section é carregada
  function initializeCarrosselInfluencers(section) {
    const influencers = section.querySelector(".carrossel-influencers");

    if (influencers) {
      influencers
        .querySelectorAll(".carrossel-influencers-item")
        .forEach((item) => {
          item.addEventListener("click", () => {
            // Fecha todos os outros itens no mesmo carrossel
            influencers
              .querySelectorAll(".carrossel-influencers-item")
              .forEach((i) => {
                if (i !== item) {
                  i.classList.remove("active");
                }
              });

            // Alterna o estado do item clicado
            item.classList.toggle("active");
          });
        });

      // Adiciona eventos de clique nos botões de copiar
      influencers.querySelectorAll("button").forEach((button) => {
        button.addEventListener("click", function () {
          const couponElement = this.closest(
            ".carrossel-influencers-item"
          ).querySelector(".carrossel-influencers-cupom");

          if (couponElement) {
            const couponText = couponElement.textContent.trim();
            navigator.clipboard
              .writeText(couponText)
              .then(() => {
                alert(`Cupom "${couponText}" copiado, aproveite!`);
              })
              .catch((err) => {
                console.error("Erro ao copiar o cupom: ", err);
                alert("Não foi possível copiar o cupom. Tente novamente.");
              });
          }
        });
      });
    }
  }

  // Inicializa para carrosséis já carregados
  document.querySelectorAll("[data-accordion]").forEach((section) => {
    initializeCarrosselInfluencers(section);
  });

  // Reaplica eventos ao carregar novas sections no editor Shopify
  document.addEventListener("shopify:section:load", function (event) {
    const section = event.target;
    initializeCarrosselInfluencers(section);
  });
});
